import React from 'react';
import intl from 'react-intl-universal';
import SweetAlert from 'react-bootstrap-sweetalert/lib/dist/SweetAlert';

// modal TEMPORÁRIO para mostrar erros para o usuário antes de redirecionar para o front novo,
// já que antes mostravamos o erro na home depois de redirecionar

const BaseModal = ({
  type,
  message,
  children,
  onClose = () => { window.location.href = '/'; },
  ...props
}) => {
  return (
    <SweetAlert
      title=""
      type={type}
      onConfirm={onClose}
      onCancel={onClose}
      confirmBtnText={intl.get('ok')}
      {...props}
    >
      {message}
      {children}
    </SweetAlert>
  );
}

export const SuccessModal = (props) => (
  <BaseModal type="success" showConfirm {...props}>
    {props.children}
  </BaseModal>
);

export const ErrorModal = (props) => (
  <BaseModal
    type="warning"
    message={props.message ?? intl.get('sem_permissao')}
    {...props}
  >
    {props.children}
  </BaseModal>
);



export default ErrorModal;